<div #promptBarContainer
class="copilot-prompt-bar-input-container"
    [class.disabled]="isInputDisabled"
    (click)="focusPromptInput()"
    [tp]="isExpiredUser ? PremiumTooltipTemplate : null"
    [tpClassName]="'custom-tooltip'"
    [tpPlacement]="'bottom'"
    [tpOffset]="[0, -35]">
    <ng-template #PremiumTooltipTemplate> <app-premium-tooltip [text]="tooltips.premium.polarisPrompts"></app-premium-tooltip> </ng-template>

    @if (showModelSelector) {
      <app-polaris-model-selector
          class="copilot-prompt-bar-model-selector"
          [selectedModel]="selectedModel"
          [disabled]="modelSelectorDisabled"
          (modelChange)="modelChange.emit($event)"
          (click)="$event.stopPropagation()">
      </app-polaris-model-selector>
    }
    @if (shouldDisplayExtraButtons) {
    <div class="copilot-prompt-bar-input-icon-container">
        <app-coming-soon class="coming-soon" [isVisible]="isGalleryHovered"></app-coming-soon>
        <img class="copilot-prompt-bar-input-icon" [src]="'svg/gallery.svg' | assetVersion" (mouseenter)="isGalleryHovered = true" (mouseleave)="isGalleryHovered = false" (click)="$event.stopPropagation()">
    </div>
    <div class="copilot-prompt-bar-input-icon-container">
        <app-coming-soon class="coming-soon" [isVisible]="isClipHovered"></app-coming-soon>
        <img class="copilot-prompt-bar-input-icon" [src]="'svg/paperclip.svg' | assetVersion" (mouseenter)="isClipHovered = true" (mouseleave)="isClipHovered = false" (click)="$event.stopPropagation()">
    </div>
    }
    <textarea #promptInput data-testid="polaris-prompt-input" type="text" class="copilot-prompt-bar-input" [placeholder]=placeholder (input)="resizeTextArea()" (scroll)="updateFade()" [formControl]="promptControl" (keydown.enter)="onSend($event)"></textarea>
    <div class="copilot-prompt-bar-send-button" (click)="$event.stopPropagation(); onSend()">
        <img [src]="'svg/send.svg' | assetVersion">
    </div>
</div>
